import React from 'react';
import { NavLink } from 'react-router-dom';
import { openAccountLink } from '../../utils/navigation';
import Popup from '../Popup/Popup';
import styles from './DirectLandingPage.css';
import crossIcon from '../../images/cross-icon.svg';
/* TARGET DATE FUNDS */
import incomImg from '../../images/IncomeFunds.jpg';
import retirImg from '../../images/RetirementFunds.jpg';
import targtImg from '../../images/TargetFunds.jpg';

import Breadcrumb from '../Breadcrumb/Breadcrumb';
import DirectlandingPageMeta from './DirectlandingPageMeta';
import Claims from '../Claims/Claims';

const popUpStyle = {
    borderRadius: '8px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
    width: '665px',
    maxWidth: '100%',
    overflow: 'auto'
};

class TargetDateFundLandingPage extends React.Component {
    constructor(props) {
        super(props);
        const hashlink = props.hashlink || '';
        let activeTabParam = 'retFunds';
        if (hashlink === '#TargetFunds') {
            activeTabParam = 'tarFunds';
        } else if (hashlink === '#IncomeFunds') {
            activeTabParam = 'incFunds';
        }
        this.state = {
            activeTab: activeTabParam,
            openretirGP: false,
            opentargtGP: false
        };
    }

    tabClick = (tabname) => {
        this.setState({
            activeTab: tabname
        });
    };

    toggleModal = (type) =>
        type === 'retirement'
            ? this.setState((prevState) => ({
                  openretirGP: !prevState.openretirGP
              }))
            : this.setState((prevState) => ({
                  opentargtGP: !prevState.opentargtGP
              }));

    closeModal = (type) =>
        type === 'retirement'
            ? this.setState({ openretirGP: false })
            : this.setState({ opentargtGP: false });

    tdfImage = (tabname) => {
        if (tabname === 'tarFunds') {
            return targtImg;
        }
        if (tabname === 'incFunds') {
            return incomImg;
        }
        return retirImg;
    };

    render() {
        const { activeTab } = this.state;
        return (
            <React.Fragment>
                <DirectlandingPageMeta pagename="Target Date Funds" />
                <div className="text-col">
                    <div className="text-col-body">
                        <Breadcrumb name="Target Date Funds" />
                        <h1>Target Date Funds</h1>
                        <div className="SI-tabview-container">
                            <div className="SI-nav">
                                <div
                                    className={`SI-tab-label ${
                                        activeTab === 'retFunds' ? 'active' : ''
                                    }`}
                                >
                                    <a
                                        onClick={() =>
                                            this.tabClick('retFunds')
                                        }
                                        onKeyDown={() =>
                                            this.tabClick('retFunds')
                                        }
                                        href={`${
                                            window.location.pathname
                                        }#RetirementFunds`}
                                        data-metrics-type="TAB"
                                        role="tab"
                                        id="RetirementFunds"
                                        tabIndex={0}
                                    >
                                        <div className="tab-label">
                                            Retirement<br /> Funds
                                        </div>
                                    </a>
                                </div>
                                <div
                                    className={`SI-tab-label ${
                                        activeTab === 'tarFunds' ? 'active' : ''
                                    }`}
                                >
                                    <a
                                        onClick={() =>
                                            this.tabClick('tarFunds')
                                        }
                                        onKeyDown={() =>
                                            this.tabClick('tarFunds')
                                        }
                                        href={`${
                                            window.location.pathname
                                        }#TargetFunds`}
                                        data-metrics-type="TAB"
                                        role="tab"
                                        id="TargetFunds"
                                        tabIndex={0}
                                    >
                                        <div className="tab-label">
                                            Target<br /> Funds
                                        </div>
                                    </a>
                                </div>
                                <div
                                    className={`SI-tab-label ${
                                        activeTab === 'incFunds' ? 'active' : ''
                                    }`}
                                >
                                    <a
                                        onClick={() =>
                                            this.tabClick('incFunds')
                                        }
                                        onKeyDown={() =>
                                            this.tabClick('incFunds')
                                        }
                                        href={`${
                                            window.location.pathname
                                        }#IncomeFunds`}
                                        data-metrics-type="TAB"
                                        role="tab"
                                        id="IncomeFunds"
                                        tabIndex={0}
                                    >
                                        <div className="tab-label">
                                            Income<br /> Funds
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* Retirement Funds */}
                        {activeTab === 'retFunds' && (
                            <React.Fragment>
                                <h2>
                                    Achieve a diversified investment portfolio
                                    -- in one easy step
                                </h2>
                                <blockquote className="claim">
                                    <Claims
                                        pathToClaim="/personal-investing/funds/claims/target-date.model.json"
                                        styles={styles}
                                    />
                                </blockquote>
                                <p>
                                    Our deeply experienced investment team --
                                    averaging 22 years in the industry --
                                    manages the underlying investments. So you
                                    can be sure your money is in good hands.
                                </p>
                                <p>
                                    To get a more detailed profile, including
                                    standardized returns as of the most recent
                                    calendar quarter end, click on any fund
                                    name.
                                </p>
                                <p>
                                    <a
                                        id="retirement-glidepath"
                                        className="retgp"
                                        data-metrics-link-text="Funds allocation Retirement"
                                        onClick={() =>
                                            this.toggleModal('retirement')
                                        }
                                        onKeyDown={() =>
                                            this.toggleModal('retirement')
                                        }
                                        href={`${
                                            window.location.pathname
                                        }#glidepathRetirement`}
                                        role="button"
                                        tabIndex={0}
                                    >
                                        {' '}
                                        See how the funds’ allocations adjust
                                        over time.
                                    </a>
                                </p>
                                <div>
                                    <p className="browse-all">
                                        <NavLink exact to="/">
                                            Browse all T. Rowe Price Mutual
                                            Funds
                                        </NavLink>
                                    </p>
                                    <div className="ready-wrapper">
                                        <span className="intro">
                                            Ready to get started?<br />
                                        </span>
                                        <a
                                            id="openaccout-dl"
                                            href={openAccountLink()}
                                        >
                                            Open an Account
                                        </a>&nbsp;
                                        <span>or call 866-264-5579</span>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}

                        {/* Target Funds */}

                        {activeTab === 'tarFunds' && (
                            <React.Fragment>
                                <h2>
                                    Invest for retirement with less volatility
                                </h2>
                                <p>
                                    These funds seek to reduce volatility as you
                                    near retirement and may better support
                                    withdrawals over a shorter time period.
                                </p>
                                <p>
                                    They offer lower volatility -- and lower
                                    potential long-term growth -- than
                                    Retirement Funds by emphasizing bonds near
                                    the target date.
                                </p>
                                <p>
                                    To get a more detailed profile, including
                                    standardized returns as of the most recent
                                    calendar quarter end, click on any fund
                                    name.
                                </p>
                                <p>
                                    <a
                                        id="target-glidepath"
                                        data-metrics-link-text="Funds allocation Target Date"
                                        onClick={() =>
                                            this.toggleModal('target')
                                        }
                                        onKeyDown={() =>
                                            this.toggleModal('target')
                                        }
                                        href={`${
                                            window.location.pathname
                                        }#glidepathTarget`}
                                        className="trggp"
                                        role="button"
                                        tabIndex={0}
                                    >
                                        See how the funds’ allocations adjust
                                        over time.
                                    </a>
                                </p>
                                <div>
                                    <p className="browse-all">
                                        <NavLink exact to="/">
                                            Browse all T. Rowe Price Mutual
                                            Funds
                                        </NavLink>
                                    </p>
                                    <div className="ready-wrapper">
                                        <span className="intro">
                                            Ready to get started?<br />
                                        </span>
                                        <a
                                            id="openaccout-dl"
                                            href={openAccountLink()}
                                        >
                                            Open an Account
                                        </a>&nbsp;
                                        <span>or call 866-264-5579</span>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                        {/* Income Funds */}

                        {activeTab === 'incFunds' && (
                            <React.Fragment>
                                <h2>
                                    Turn your investments into automatic income
                                </h2>
                                <p>
                                    These funds are designed for people in or
                                    nearing retirement who are looking for
                                    regular monthly payouts from their
                                    investments.
                                </p>
                                <p>
                                    They offer ongoing monthly dividend income
                                    with the convenience of ready access to your
                                    money when you need it.
                                </p>
                                <p>
                                    To get a more detailed profile, including
                                    standardized returns as of the most recent
                                    calendar quarter end, click on any fund
                                    name.
                                </p>
                                <p>
                                    <a
                                        id="tdf-incomefunds"
                                        data-metrics-link-text="Funds allocation Income"
                                        href="https://www.troweprice.com/personal-investing/mutual-funds/target-date-funds/income-funds.html"
                                    >
                                        See more about Income Funds, including
                                        how the funds’ allocations adjust over
                                        time.
                                    </a>
                                </p>
                                <div>
                                    <p className="browse-all">
                                        <NavLink exact to="/">
                                            Browse all T. Rowe Price Mutual
                                            Funds
                                        </NavLink>
                                    </p>
                                    <div className="ready-wrapper">
                                        <span className="intro">
                                            Ready to get started?<br />
                                        </span>
                                        <a
                                            id="openaccout-dl"
                                            href={openAccountLink()}
                                        >
                                            Open an Account
                                        </a>&nbsp;
                                        <span>or call 866-264-5579</span>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </div>
                <div className="img-col">
                    <div>
                        <img
                            alt="Invest With Confidence"
                            src={this.tdfImage(activeTab)}
                        />
                        <div>
                            <p className="browse-all">
                                <NavLink exact to="/">
                                    Browse all T. Rowe Price Mutual Funds
                                </NavLink>
                            </p>
                            <div className="ready-wrapper">
                                <span className="intro">
                                    Ready to get started?<br />
                                </span>
                                <a id="openaccout-dl" href={openAccountLink()}>
                                    Open an Account
                                </a>&nbsp;
                                <span>or call 866-264-5579</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Retirement Funds Glide Path */}
                <Popup
                    open={this.state.openretirGP}
                    closeOnDocumentClick
                    closeOnEscape
                    onClose={() => this.closeModal('retirement')}
                    overlayStyle={{ overflow: 'auto' }}
                    contentStyle={popUpStyle}
                >
                    <div className="modal">
                        <button
                            className="close-btn"
                            style={{ float: 'right' }}
                            onClick={() => this.closeModal('retirement')}
                            type="button"
                        >
                            <img
                                className="close-btn-img"
                                alt="Close"
                                src={crossIcon}
                            />
                        </button>
                        <div className="modal-title">
                            Retirement Funds Glide Path
                        </div>
                        <img
                            src="https://www.troweprice.com/content/dam/iinvestor/mutual-funds/retirement-funds-enhanced-glidepath.png"
                            alt="Retirement Funds Glide Path Graph"
                            width="100%"
                        />
                    </div>
                </Popup>
                {/* Target Funds Glide Path */}
                <Popup
                    open={this.state.opentargtGP}
                    closeOnDocumentClick
                    closeOnEscape
                    onClose={() => this.closeModal('target')}
                    contentStyle={popUpStyle}
                >
                    <div className="modal">
                        <button
                            className="close-btn"
                            style={{ float: 'right' }}
                            onClick={() => this.closeModal('target')}
                            type="button"
                        >
                            <img
                                className="close-btn-img"
                                alt="Close"
                                src={crossIcon}
                            />
                        </button>
                        <div className="modal-title">
                            Target Funds Glide Path
                        </div>
                        <img
                            src="https://www.troweprice.com/content/dam/iinvestor/mutual-funds/target-funds-enhanced-glidepath.png"
                            alt="Target Funds Glide Path Graph"
                            width="100%"
                        />
                    </div>
                </Popup>

                <style jsx>{styles}</style>
            </React.Fragment>
        );
    }
}

export default TargetDateFundLandingPage;
